/* istanbul ignore file */
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { spacing } = themeVariables;

export const singleRoot = css`
  position: relative;
`;

export const grid = css`
  display: grid;
  gap: var(${spacing.xs});
`;

export const thumbnailRow = css`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(${spacing.xs});
`;

export const thumbnailWrapper = css`
  position: relative;
`;

export const cell = css`
  position: relative;
  display: block;
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  border: none;
  background-color: transparent;
  padding-left: 0;
  padding-right: 0;
  cursor: pointer;
`;

export const cellMedia = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
